module.exports = __webpack_public_path__ + "static/media/Sec-3_Content_VN_Mobile.53a2b10d.webp";